export default __webpack_public_path__ + "static/media/1221.ce218358.png";